import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'app-calculate-certifiable-lactation-modal',
	templateUrl: './calculate-certifiable-lactation-modal.component.html',
	styleUrls: ['./calculate-certifiable-lactation-modal.component.scss'],
})
export class CalculateCertifiableLactationModalComponent implements OnInit {
	isHistoricFilterEnabled: boolean = false;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialogRef: MatDialogRef<CalculateCertifiableLactationModalComponent>
	) {}

	ngOnInit(): void {}

	closeDialog(mode: 'all' | 'filters' | null): void {
		this.dialogRef.close({ mode, isHistoricFilterEnabled: this.isHistoricFilterEnabled });
	}
}
